/// <reference lib="dom" />
export const crypto = globalThis.crypto;
//# sourceMappingURL=crypto.web.js.map